import { render, staticRenderFns } from "./PageBalance.vue?vue&type=template&id=4c47813a&"
import script from "./PageBalance.vue?vue&type=script&lang=ts&"
export * from "./PageBalance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports